import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment.development';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { SessionService } from '../../../auth/services/session/session.service';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class EventsService {
  private readonly http = inject(HttpClient);
  private readonly sessionService = inject(SessionService);
  private readonly localStorage = inject(LocalStorageService);
  private readonly url = `${environment.apiUrl}/administrative/events/`;

  getEvents(filters: any): Observable<any> {
    const customer = this.sessionService.Customer;
    let params = new HttpParams().set('customer', customer.id);

    if (customer.is_main) {
      params = params.set('customer__main_customer', customer.id);
    }

    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });

    const token = this.localStorage.get(STORAGE_ENUM.TOKEN);
    return this.http.get<any>(this.url, {
      headers: { Authorization: token ? `Bearer ${token}` : '' },
      params
    });
  }
}
